import React, { createContext, useCallback, useEffect, useState } from 'react';
import { useCookieWatcher } from '../hooks/useCookieWatcher';

export const VideoModalContext = createContext({
  showModal: false,
  watchVideo: {},
  cookieConsent: false,
  openVideoModal: (video) => {},
  closeVideoModal: () => {},
});

export const VideoModalProvider = ({ children }) => {
  const [cookieConsent, setCookieConsent] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [watchVideo, setWatchVideo] = useState({});

  // Watch CookieYes cookie value
  const cookie = useCookieWatcher('cookieyes-consent', { valueOnly: true });

  // Parse cookie consent on mount and cookie changes
  useEffect(() => {
    if (!cookieConsent) {
      if (cookie !== null && typeof cookie !== 'undefined') {
        // Convert string to object
        const parsedCookie = cookie.split(',').reduce((prev, current) => {
          const [name, ...value] = current.split(':');
          prev[name] = value.join(':');
          return prev;
        }, {});
        // If user has accepted advertisement cookies, set state to true
        if (parsedCookie?.advertisement) {
          setCookieConsent(parsedCookie.advertisement === 'yes');
        }
      }
    }
  }, [cookie, cookieConsent]);

  const openVideoModal = useCallback((video) => {
    setWatchVideo(video);
    setShowModal(true);
  }, []);

  const closeVideoModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const value = {
    showModal,
    watchVideo,
    cookieConsent,
    openVideoModal,
    closeVideoModal,
  };

  return (
    <VideoModalContext.Provider value={value}>
      {children}
    </VideoModalContext.Provider>
  );
};
